import React from 'react';
import Hero from '../components/home/Hero';
import ToolsSection from '../components/home/ToolsSection.jsx';
import EducationPlatformSection from '../components/home/EducationPlatformSection.jsx';
import CommunitySection from '../components/home/CommunitySection.jsx';
import ResourcesSupportSection from '../components/home/ResourcesSupportSection.jsx';
// Ya no importamos el Footer aquí

function Home() {
  return (
    <>
      <Hero />
      <ToolsSection />

      <section className="triple-card-section">
        <div className="container">
          <EducationPlatformSection />
          <CommunitySection />
          <ResourcesSupportSection />
        </div>
      </section>
      
      {/* Ya no llamamos al Footer aquí */}
    </>
  );
}

export default Home;